
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Pau dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Pau certifiée Google Partner, accompagne les entreprises paloises pour accroître leur visibilité en ligne et capter de nouveaux prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Pau dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Pau certifiée Google Partner, accompagne les entreprises paloises pour accroître leur visibilité en ligne et capter de nouveaux prospects.",
        },
      ],
    };
  },
};
